/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGateData } from '../../models/bundle-gate-data';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetGateData$Params {
  token: Token64LengthType;
}

export function externalGetGateData(http: HttpClient, rootUrl: string, params: ExternalGetGateData$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGateData>> {
  const rb = new RequestBuilder(rootUrl, externalGetGateData.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGateData>;
    })
  );
}

externalGetGateData.PATH = '/external/gate';
